import { render, staticRenderFns } from "./pedidos-mudanca-estudante.vue?vue&type=template&id=9fce2a9a&"
import script from "./pedidos-mudanca-estudante.vue?vue&type=script&lang=js&"
export * from "./pedidos-mudanca-estudante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports